import React from 'react'

export default function Footer() {
  return (
    <footer>          
    <a href='https://globalsoftwares.net/' target='_blank' rel='noreferrer'>www.<span>global</span>softwares.net</a>
    {/* <ul className='contreinfo'>
      <li>India</li>
      <li>Tanzania</li>
      <li>u.a.e</li>
      <li>Angola</li>
      </ul> */}
    </footer>
  )
}
